import React, { useState, useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "./components/Globals/Header.js";
import ONMain from "./pages/Ontario/ONMain.js";
import "../src/styles/App.css";
import Footer from "./components/Globals/Footer.js";
import { Routes, Route } from "react-router-dom";
import headerMenu from "../src/components/Globals/headerMenu.js";
import TRESA from "./pages/Ontario/TRESA.js";
import CommonForms from "./pages/Ontario/CommonForms.js";
import ChecklistsMenu from "./pages/Ontario/ChecklistsMenu.js";
import CoCBoxes from "./pages/Ontario/CoCBoxes.js";
import ClauseGenerator from "./pages/Ontario/ClauseGenerator.js";
import Home from "./pages/Home.js";
import PageNotFound from "./components/Globals/PageNotFound.js";
import OfficeProcedures from "./pages/Ontario/OfficeProcedures.js";
import ABMain from "./pages/Alberta/ABMain.js";
import ABBestPractices from "./pages/Alberta/ABBestPractices.js";
import ABChecklists from "./pages/Alberta/ABChecklists.js";
import ABCommonForms from "./pages/Alberta/ABCommonForms.js";
import ABOfficeProcedures from "./pages/Alberta/ABOfficeProcedures.js";
import YTMain from "./pages/Yukon/YTMain.js";
import YTBestPractices from "./pages/Yukon/YTBestPractices.js";
import YTChecklists from "./pages/Yukon/YTChecklists.js";
import YTCommonForms from "./pages/Yukon/YTCommonForms.js";
import YTOfficeProcedures from "./pages/Yukon/YTOfficeProcedures.js";
import BCMain from "./pages/BritishColumbia/BCMain.js";
import BCChecklistsMenu from "./pages/BritishColumbia/BCChecklistsMenu.js";
import BCBestPractices from "./pages/BritishColumbia/BCBestPractices.js";
import BCCommonForms from "./pages/BritishColumbia/BCCommonForms.js";
import BCOfficeProcedures from "./pages/BritishColumbia/BCOfficeProcedures.js";
import NLMain from "./pages/Newfoundland/NLMain.js";
import NLTRESA from "./pages/Newfoundland/TRESA.js";
import NLCommonForms from "./pages/Newfoundland/CommonForms.js";
import NLChecklistsMenu from "./pages/Newfoundland/ChecklistsMenu.js";
import NLOfficeProcedures from "./pages/Newfoundland/OfficeProcedures.js";
import NBMain from "./pages/NewBrunswick/NBMain.js";
import NBTRESA from "./pages/NewBrunswick/TRESA.js";
import NBCommonForms from "./pages/NewBrunswick/CommonForms.js";
import NBChecklistsMenu from "./pages/NewBrunswick/ChecklistsMenu.js";
import NBOfficeProcedures from "./pages/NewBrunswick/OfficeProcedures.js";
import MBMain from "./pages/Manitoba/MBMain.js";
import MBTRESA from "./pages/Manitoba/TRESA.js";
import MBCommonForms from "./pages/Manitoba/CommonForms.js";
import MBChecklistsMenu from "./pages/Manitoba/ChecklistsMenu.js";
import MBOfficeProcedures from "./pages/Manitoba/OfficeProcedures.js";
import SKMain from "./pages/Saskatchewan/SKMain.js";
import SKTRESA from "./pages/Saskatchewan/TRESA.js";
import SKCommonForms from "./pages/Saskatchewan/CommonForms.js";
import SKChecklistsMenu from "./pages/Saskatchewan/ChecklistsMenu.js";
import SKOfficeProcedures from "./pages/Saskatchewan/OfficeProcedures.js";
import QCMain from "./pages/Quebec/QCMain.js";
import QCTRESA from "./pages/Quebec/TRESA.js";
import QCCommonForms from "./pages/Quebec/CommonForms.js";
import QCChecklistsMenu from "./pages/Quebec/ChecklistsMenu.js";
import QCOfficeProcedures from "./pages/Quebec/OfficeProcedures.js";

function App() {
  const { authState, oktaAuth } = useOktaAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [MenuSelect, setMenuSelect] = useState("");
  const [Province, setProvince] = useState("");

  // ✅ Ensure authentication state is loaded before redirecting
  useEffect(() => {
    if (authState === null) {
      return; // Wait until authState is loaded
    }

    if (!authState?.isAuthenticated) {
      // ✅ Store the current URL before redirecting
      sessionStorage.setItem(
        "preLoginUrl",
        location.pathname + location.search
      );
      oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth, location]);

  // ✅ Restore user to the stored URL after login
  useEffect(() => {
    if (authState?.isAuthenticated) {
      const storedUri = sessionStorage.getItem("preLoginUrl");
      if (storedUri) {
        sessionStorage.removeItem("preLoginUrl"); // Prevent stale redirects
        navigate(storedUri, { replace: true });
      }
    }
  }, [authState, navigate]);

  // ✅ Fix: Ensure app doesn't get stuck waiting for authState
  if (authState === null) {
    return <h2>Loading authentication...</h2>;
  }

  return (
    <>
      <div className="app w-full flex flex-col items-center">
        <Header
          MenuSelect={MenuSelect}
          setMenuSelect={setMenuSelect}
          MenuData={headerMenu.filter((item) => item.province === Province)}
          Province={Province}
        />

        <div className="w-full body max-w-5xl">
          <Routes>
            <Route path="*" element={<PageNotFound />} />
            <Route
              path="/"
              element={<Home Province={Province} setProvince={setProvince} />}
            />

            <Route path="/ON" element={<ONMain setProvince={setProvince} />} />
            <Route
              path="/ontario"
              element={<ONMain setProvince={setProvince} />}
            />
            <Route
              path="/ON/office-procedures"
              element={<OfficeProcedures setProvince={setProvince} />}
            />
            <Route
              path="/ON/transaction-best-practices"
              element={<TRESA setProvince={setProvince} />}
            />
            <Route
              path="/ON/common-forms"
              element={<CommonForms setProvince={setProvince} />}
            />
            <Route
              path="/ON/transaction-checklists"
              element={<ChecklistsMenu setProvince={setProvince} />}
            />
            <Route
              path="/ON/form-320"
              element={<CoCBoxes setProvince={setProvince} />}
            />
            <Route
              path="/ON/clause-generator"
              element={<ClauseGenerator setProvince={setProvince} />}
            />
            <Route path="/AB" element={<ABMain setProvince={setProvince} />} />
            <Route
              path="/AB/transaction-checklists"
              element={<ABChecklists setProvince={setProvince} />}
            />
            <Route
              path="/AB/common-forms"
              element={<ABCommonForms setProvince={setProvince} />}
            />
            <Route
              path="/AB/best-practices"
              element={<ABBestPractices setProvince={setProvince} />}
            />
            <Route
              path="/AB/office-procedures"
              element={<ABOfficeProcedures setProvince={setProvince} />}
            />
            <Route path="/YT" element={<YTMain setProvince={setProvince} />} />
            <Route
              path="/YT/transaction-checklists"
              element={<YTChecklists setProvince={setProvince} />}
            />
            <Route
              path="/YT/common-forms"
              element={<YTCommonForms setProvince={setProvince} />}
            />
            <Route
              path="/YT/best-practices"
              element={<YTBestPractices setProvince={setProvince} />}
            />
            <Route
              path="/YT/office-procedures"
              element={<YTOfficeProcedures setProvince={setProvince} />}
            />
            <Route path="/BC" element={<BCMain setProvince={setProvince} />} />

            <Route
              path="/BC/office-procedures"
              element={<BCOfficeProcedures setProvince={setProvince} />}
            />
            <Route
              path="/BC/best-practices"
              element={<BCBestPractices setProvince={setProvince} />}
            />
            <Route
              path="/BC/common-forms"
              element={<BCCommonForms setProvince={setProvince} />}
            />
            <Route
              path="/BC/transaction-checklists"
              element={<BCChecklistsMenu setProvince={setProvince} />}
            />
            <Route path="/NL" element={<NLMain setProvince={setProvince} />} />
            <Route
              path="/newfoundland"
              element={<NLMain setProvince={setProvince} />}
            />
            <Route
              path="/NL/office-procedures"
              element={<NLOfficeProcedures setProvince={setProvince} />}
            />
            <Route
              path="/NL/transaction-best-practices"
              element={<NLTRESA setProvince={setProvince} />}
            />
            <Route
              path="/NL/common-forms"
              element={<NLCommonForms setProvince={setProvince} />}
            />
            <Route
              path="/NL/transaction-checklists"
              element={<NLChecklistsMenu setProvince={setProvince} />}
            />
            <Route path="/NB" element={<NBMain setProvince={setProvince} />} />
            <Route
              path="/new-brunswick"
              element={<NBMain setProvince={setProvince} />}
            />
            <Route
              path="/NB/office-procedures"
              element={<NBOfficeProcedures setProvince={setProvince} />}
            />
            <Route
              path="/NB/transaction-best-practices"
              element={<NBTRESA setProvince={setProvince} />}
            />
            <Route
              path="/NB/common-forms"
              element={<NBCommonForms setProvince={setProvince} />}
            />
            <Route
              path="/NB/transaction-checklists"
              element={<NBChecklistsMenu setProvince={setProvince} />}
            />
            <Route path="/MB" element={<MBMain setProvince={setProvince} />} />
            <Route
              path="/manitoba"
              element={<MBMain setProvince={setProvince} />}
            />
            <Route
              path="/MB/office-procedures"
              element={<MBOfficeProcedures setProvince={setProvince} />}
            />
            <Route
              path="/MB/transaction-best-practices"
              element={<MBTRESA setProvince={setProvince} />}
            />
            <Route
              path="/MB/common-forms"
              element={<MBCommonForms setProvince={setProvince} />}
            />
            <Route
              path="/MB/transaction-checklists"
              element={<MBChecklistsMenu setProvince={setProvince} />}
            />
            <Route path="/SK" element={<SKMain setProvince={setProvince} />} />
            <Route
              path="/saskatchewan"
              element={<SKMain setProvince={setProvince} />}
            />
            <Route
              path="/SK/office-procedures"
              element={<SKOfficeProcedures setProvince={setProvince} />}
            />
            <Route
              path="/SK/transaction-best-practices"
              element={<SKTRESA setProvince={setProvince} />}
            />
            <Route
              path="/SK/common-forms"
              element={<SKCommonForms setProvince={setProvince} />}
            />
            <Route
              path="/SK/transaction-checklists"
              element={<SKChecklistsMenu setProvince={setProvince} />}
            />
            <Route path="/QC" element={<QCMain setProvince={setProvince} />} />
            <Route
              path="/quebec"
              element={<QCMain setProvince={setProvince} />}
            />
            <Route
              path="/QC/office-procedures"
              element={<QCOfficeProcedures setProvince={setProvince} />}
            />
            <Route
              path="/QC/transaction-best-practices"
              element={<QCTRESA setProvince={setProvince} />}
            />
            <Route
              path="/QC/common-forms"
              element={<QCCommonForms setProvince={setProvince} />}
            />
            <Route
              path="/QC/transaction-checklists"
              element={<QCChecklistsMenu setProvince={setProvince} />}
            />
          </Routes>
        </div>

        <Footer MenuSelect={MenuSelect} setMenuSelect={setMenuSelect} />
      </div>
    </>
  );
}

export default App;
